import type { DmLastResolution } from '../../../services/dmNotifications';
import { formatDateTime, formatRelativeActivity } from '../../../utils/dates';
import { closureText } from '../notifications/view/resolvedNotificationText';

// A closed row's stand-in for Waiting: when the patient's latest item closed, and how.
export function ClosureCell({ resolution }: { resolution: DmLastResolution | null }) {
    if (!resolution) return <span className="text-xs text-gray-400">-</span>;
    const text = closureText(resolution);
    return (
        <div className="min-w-0 leading-tight">
            <time
                dateTime={resolution.resolvedAt}
                title={formatDateTime(resolution.resolvedAt)}
                className="block whitespace-nowrap text-xs text-gray-700 tabular-nums"
            >
                {formatRelativeActivity(resolution.resolvedAt)}
            </time>
            <span className="block truncate text-[11px] text-gray-400" title={text}>
                {text}
            </span>
        </div>
    );
}
